export function getCssSizeValue<Value extends number | string | null | undefined>(
  value: Value
): Value extends null | undefined ? undefined : string {
  // @ts-ignore
  return value == null ? undefined : typeof value === 'number' ? `${value}px` : value;
}
